module.exports = new __parcel__URL__("Shamanskill_06.91e48a46.png").toString();